<template>
<div class="addCar">
  <div class="carBlock">
    <div class="title">车主信息</div>
    <div class="userInfo">
      <div class="item">
        <div class="key">姓名</div>
        <span v-if="isName">{{memberInfo.Name}}</span>
        <input v-else type="text" class="value" v-model="memberInfo.Name" placeholder="请输入车主姓名"/>
      </div>
      <div class="item">
        <div class="key">手机号</div>
        <span>{{memberInfo.Telephone}}</span>
      </div>
    </div>
    <div class="title">车辆信息</div>
    <div class="carInfo">
      <div class="item">
        <div class="key">车牌号</div>
        <div>
          <input type="text" class="value" maxlength="8" v-model="userInfo.CarNumber" placeholder="请输入,例鄂A88888"/>
        </div>
      </div>
      <div class="item">
        <div class="key">品牌车型</div>
        <input type="text" class="value" v-model="userInfo.CarClass" placeholder="请输入,例宝马X62017款"/>
      </div>
      <div class="item">
        <div class="key">上线城市</div>
        <div class="switchBlock" @click="ChoiceCity">
          <input type="text" class="value switch" v-model="cityInfo.city" placeholder="请选择" readonly/>
          <i class="iconfont icon-arrow-right"></i>
        </div>
      </div>
      <div class="item">
        <div class="key">上线地址</div>
        <div class="switchBlock" @click="ChoiceAddress" >
          <input type="text" class="value switch" v-model="addressInfo.name" placeholder="请选择" readonly/>
          <i class="iconfont icon-arrow-right"></i>
        </div>
      </div>
      <div class="item" v-if="!hasReferee">
        <div class="key">邀请人手机号</div>
        <input type="text" class="value" v-model="userInfo.RefereePhone" placeholder="请输入邀请人手机号" maxlength="11"/>
      </div>
    </div>
    <div class="subbtn" @click="subApplications">提交申请</div>
  </div>
</div>
</template>
<script>
  import { apply , getCurrentMemberInfo } from "@/utils/api";
    export default {
      name: "addCar",
      components: {
      },
      data () {
        return {
          isName:false,
          userInfo:{
            CarClass:'',
            CarNumber:'',
            RefereePhone:""
          },
          cityInfo:{},
          addressInfo:{},
          memberInfo:{
            Name:'',
            Telephone:'',
          },
          hasReferee: false
        }
      },
      components: {

      },
      created() {
        if(localStorage.getItem('memberInfo')){
          this.memberInfo = JSON.parse(localStorage.getItem('memberInfo'));
        }
        //获取城市
        if(localStorage.getItem('cityInfo')){
          this.cityInfo = JSON.parse(localStorage.getItem('cityInfo'));
        }
        //获取地址
        if(localStorage.getItem('addressInfo')){
          this.addressInfo = JSON.parse(localStorage.getItem('addressInfo'));
        }
        //获取用户信息
        if(localStorage.getItem('userInfo')){
          this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
          if(this.userInfo.City){
            this.cityInfo.city = this.userInfo.City;
            this.addressInfo.name = this.userInfo.Address;
          }
          localStorage.setItem("cityInfo", JSON.stringify(this.cityInfo));
          localStorage.setItem("addressInfo", JSON.stringify(this.addressInfo));
        }
      },
      mounted() {
        if(!localStorage.getItem('memberInfo')){
            this.getUserInfo();
        }
      },
      methods: {
        async getUserInfo(){
          let res = await getCurrentMemberInfo();
          if(res.Code == 100){
            if(res.Data.Name){
              this.isName = true;
            }
            res.Data.RefereeID?this.hasReferee = true : this.hasReferee = false;
            this.memberInfo = res.Data;
          }
        },
        async subApplications(){
          if(!this.memberInfo.Name){
            this.flexible.showToast({
              content: '请填写姓名！',
              duration: 2000
            });
            return false;
          }
          if(!this.userInfo.CarClass){
            this.flexible.showToast({
              content: '请填写品牌车型！',
              duration: 2000
            });
            return false;
          }
          if(!this.userInfo.CarNumber || (this.userInfo.CarNumber.length != 7 && this.userInfo.CarNumber.length != 8)){
            this.flexible.showToast({
              content: this.userInfo.CarNumber ? '请填写正确的车牌':'请填写车牌号！',
              duration: 2000
            });
            return false;
          }
          let locationData = [];
          if(this.addressInfo.location){
            locationData =  this.addressInfo.location.split(',');
          }
          let data = {
            CarClass: this.userInfo.CarClass,
            CarNumber: this.userInfo.CarNumber,
            City: this.cityInfo.city,
            Address: this.addressInfo.name,
            Longitude: locationData[0] || this.userInfo.Longitude,
            Latitude: locationData[1] || this.userInfo.Latitude,
            ID: this.userInfo.ID || 0,
            RefereePhone: this.userInfo.RefereePhone
          };
          if(!this.isName){
            data.Name = this.memberInfo.Name
          }
          let res = await apply({
            data:data,
            isLoading:true,
            loadContent:'提交中...'
          });
          if(res.Code == 100){
            this.flexible.showToast({
              type: "success",
              content: "提交申请成功！",
              duration: 2000,
              success: () => {
                localStorage.removeItem("userInfo");
                localStorage.removeItem("cityInfo");
                localStorage.removeItem("addressInfo");
                localStorage.removeItem("memberInfo");
                this.$router.replace({ path: "/applySuccess" });
              }
            });
          }
        },
        ChoiceCity(){
          if(!this.isName){
            localStorage.setItem("memberInfo", JSON.stringify(this.memberInfo));
          }
          localStorage.setItem("userInfo", JSON.stringify(this.userInfo));
          this.$router.replace({ path: '/cityList' });
        },
        ChoiceAddress(){
          if(!this.isName){
            localStorage.setItem("memberInfo", JSON.stringify(this.memberInfo));
          }
          localStorage.setItem("userInfo", JSON.stringify(this.userInfo));
          localStorage.setItem("addressInfo", JSON.stringify(this.addressInfo));
          this.$router.replace({ path: '/selectAddress'});
        }
      }
    }
</script>

<style scoped lang="scss" type="text/scss">
.addCar{
  background: url("~@/assets/images/addCar/banner.jpg") no-repeat 0 0;
  background-size: 100%;
  padding-top: 250px;
  .carBlock{
    background-color: #fff;
    width: 100%;
    padding: 60px 52px 40px;
    box-sizing: border-box;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    z-index: 2;
    .title{
      padding-left: 24px;
      box-sizing: border-box;
      border-left: 10px solid #027FFF;
      font-size: 34px;
      font-weight: bold;
      color: #000000;
    }
    .userInfo,.carInfo{
      padding: 10px 0;
      box-sizing: border-box;
      .item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 0;
        margin-top: 10px;
        box-sizing: border-box;
        .key{
          color: #9f9f9f;
        }
        .value{
          position: relative;
          width: 410px;
          padding: 16px 15px;
          box-sizing: border-box;
          background: #EBEBEB;
          border-radius: 4px;
          text-align: right;
        }
        .switchBlock{
          position: relative;
          .iconfont{
            position: absolute;
            right: 5px;
            top:18px;
            color: #027FFF;
            font-weight: bold;
          }
          .citybox{
            .icon1{
              position: absolute;
              right: 330px;
              margin-top: 15px;
            }
            .city{
              position: relative;
              width: 120px;
            }
          }

          .switch{
            padding-right: 60px;
            box-sizing: border-box;
          }
        }


      }
    }
    .subbtn{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 90px;
      background: #027FFF;
      color: #ffffff;
      border-radius: 6px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/car/addCar.vue